import { FormattingRule } from "./formattingRule"

export enum CalculationType {
	Total,
	Average,
	Min,
	Max,
	Count,
	CountPerDay
}

export enum CalculationSortItemType {
	Calculation,
	CalculationTotal,
	IncludedCalculation
}

export interface InsightCalculation {
	id?: number;
	key: string;
	fieldId: string;
	calcType?: CalculationType | null;
	label: string;
	formattingRules: FormattingRule[];
	value?: number;
	groupBy?: string | null;
	field?: string;
	expression?: string | null;

	groupByKeyLabels?: { [key:string]: string }
	timeSpentCalculation?: TimeSpentCalculation;
}

export interface InsightCalculationTotal {
	key: string;
	title: string;
	calculationList: string[];
	subtractCalculationList: string[];
	value?: number;
	groupBy?: string | null;
	formattingRules?: FormattingRule[];
	expression?: string | null;

	collate: boolean
	collateInclude?: { id: string, label: string }[] | null
	collateExclude?: { id: string, label: string }[] | null
}

export interface TimeSpentCalculation {
	trackingFieldId: string;
	searchLabel: string | null;
	searchValue: string | null;
}

export interface InsightCalculationItem<T> {
	key: string
	label?: string
	type: CalculationSortItemType
	item: T
	settings: any
}

export type InsightCalculationResult = number | { [name: string]: number }
